import React, { useEffect } from "react";
import { naira } from "./walletOn";
import "./wallet.css";

// "How would you like to pay?" when the wallet can cover a paper (2026-10-31). Replaces the old silent
// automatic wallet payment: the reader always chooses. Prefix wl-.
export default function WalletChoice({ open, amount, balance, title, onWallet, onCard, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const key = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, [open]);
  if (!open) return null;
  return (
    <div className="wl-wrap wl-center" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <section className="wl-choice" role="dialog" aria-modal="true" aria-labelledby="wl-choice-title">
        <h2 id="wl-choice-title">How would you like to pay?</h2>
        {title ? <p className="wl-choice-what">{title} · <b>{naira(amount)}</b></p> : <p className="wl-choice-what"><b>{naira(amount)}</b></p>}
        <button type="button" className="wl-btn wl-pay" onClick={onWallet} autoFocus>Pay {naira(amount)} from wallet</button>
        <p className="wl-choice-left">Balance after: {naira(Math.max(0, balance - amount))}</p>
        <button type="button" className="wl-btn2" onClick={onCard}>Card, bank transfer or USSD</button>
        <button type="button" className="wl-choice-x" onClick={onClose}>Cancel</button>
      </section>
    </div>
  );
}
